import styled from 'styled-components';

const StickyBottom = styled.div.attrs<StickyBottomProperties>(({ isVisible }) => ({
    'data-sticky-bottom-visible': !isVisible
}))<StickyBottomProperties>`
    position: sticky;
    display: ${({ isVisible, active }) => isVisible || !active ? 'none' : 'block'};
    bottom: env(safe-area-inset-bottom, 0);
    border-radius: 0 0 10px 10px;
    background: var(--color-white);
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.07);
    padding: 20px 15px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0));

    @media (max-width: 1100px) {
        display: ${({ isVisible }) => isVisible ? 'none' : 'block'};
        bottom: calc(72px + env(safe-area-inset-bottom, 0));
    }
`;

interface StickyBottomProperties {
    isVisible: boolean;
    active: boolean;
}

export default StickyBottom;
